import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { BASE_URL } from '../constants'
import { IProjectManager } from '../model/interfaces'
import { getTokenFromLocalStorage } from '../../utils'
export const projectManagersApi = createApi({
  reducerPath: 'projectManagersApi',
  baseQuery: fetchBaseQuery({
    baseUrl: `${BASE_URL}/projectManager`,
    headers: { Authorization: `Bearer ${getTokenFromLocalStorage()}` }
  }),
  tagTypes: ['projectManagers', 'Projects'],
  endpoints: (builder) => ({
    getProjectManagers: builder.query<IProjectManager[], void>({
      query: () => {
        return {
          method: 'GET',
          url: '',
          headers: { Authorization: `Bearer ${getTokenFromLocalStorage()}` }
        }
      },
      providesTags: ['projectManagers']
    }),
    createProjectManager: builder.mutation<void, IProjectManager>({
      query: (projectManager: IProjectManager) => ({
        method: 'POST',
        url: '',
        body: projectManager,
        headers: { Authorization: `Bearer ${getTokenFromLocalStorage()}` }
      }),
      invalidatesTags: ['projectManagers']
    }),
    updateProjectManager: builder.mutation<void, IProjectManager>({
      query: (projectManager: IProjectManager) => ({
        method: 'PUT',
        url: `/${projectManager._id}`,
        body: projectManager,
        headers: { Authorization: `Bearer ${getTokenFromLocalStorage()}` }
      }),
      invalidatesTags: ['projectManagers', 'Projects']
    }),
    deleteProjectManager: builder.mutation<void, string>({
      query: (id: string) => ({
        method: 'DELETE',
        url: `/${id}`,
        headers: { Authorization: `Bearer ${getTokenFromLocalStorage()}` }
      }),
      invalidatesTags: ['projectManagers', 'Projects']
    })
  })
})

export const {
  useGetProjectManagersQuery,
  useLazyGetProjectManagersQuery,
  useCreateProjectManagerMutation,
  useUpdateProjectManagerMutation,
  useDeleteProjectManagerMutation
} = projectManagersApi
